// @flow

import { isServer, envConfig } from '../env'

export function stripe (): any {
  if (!isServer && window.stripeObj) {
    return window.stripeObj
  }
  if (!isServer && window.Stripe && !window.stripeObj) {
    window.stripeObj = window.Stripe(envConfig().STRIPE_KEY)
    return window.stripeObj
  }
  return {}
}
